<template>
  <section class="feedbacks">
    <slot name="before"></slot>
    <section class="feedback-list">
      <div
        v-for="feedback in feedbacks"
        :key="feedback.id"
        class="feedback"
        @click="handleClickFeedback(feedback)"
      >
        <section class="header">
          <div class="audience-info">
            <span
              v-if="feedback.audience.isAnonymous"
              class="font-bold"
            >{{ $i18nPresenter.t('Anonymous') }}</span>
            <span
              v-if="!feedback.audience.isAnonymous"
              class="font-bold truncate"
            >{{ feedback.audience.name }}</span>
            <span
              v-if="feedback.audience.email && !feedback.audience.isAnonymous"
              class="text-xs truncate text-grey"
            >{{ feedback.audience.email }}</span>
            <AhaStarRatingView
              v-if="feedback.rating"
              :rate="Number(feedback.rating)"
              size="16px"
            />
          </div>
          <aha-formatter
            class="text-xs text-grey"
            :value="feedback.createdAt"
            type="date"
            :locale="locale"
          />
        </section>
        <p v-if="feedback.comment">
          {{ feedback.comment }}
        </p>
        <p class="text-xs font-bold text-grey">
          {{ feedback.presentation.name }}
        </p>
      </div>
    </section>
    <slot name="after"></slot>
  </section>
</template>
<script>
import { mapState } from 'vuex'

export default {
  name: 'FeedbacksSectionV2',
  props: {
    feedbacks: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    ...mapState({
      locale: (state) => state.presenterLocale,
    }),
  },
  methods: {
    handleClickFeedback(feedback) {
      this.$emit('click-feedback', {
        comment: feedback.comment,
        presentationId: feedback.presentation.id,
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.feedbacks {
    @apply rounded-lg shadow-card;
    background-color: white;
    .text-grey {
        color: #848484
    }

    & > .feedback-list {
        --border-color: #D3D7E1;
        & > .feedback {
            cursor: pointer;
            padding: 1rem;
            display: flex;
            flex-direction: column;
            gap: 1rem;
            background-color: white;
            border-bottom: 1px solid var(--border-color);

            &:last-child {
                border-radius: 0 0 0.5rem 0.5rem;
                border-bottom: none;
            }

            &:hover {
              @apply bg-base-10
            }

            & .header {
                display: flex;
                justify-content: space-between;

                & > .audience-info {
                    width: 65%;
                    display: flex;
                    flex-direction: column;
                    gap: 0.5rem;
                }
            }
        }
    }
}
</style>
